import {useApolloClient, ApolloClient} from "@apollo/client";
import {HookClass} from "@dvrt/graphql-widgets";
import {MutableRefObject, useEffect, useRef, useState} from "react";
import {
    DomainNonPaymentBlockingCountQuery,
    DomainNonPaymentBlockingCountQueryVariables,
    DomainNonPaymentBlockingCountDocument,
} from "@/components/domain_settings/bulk_non_payment_blocking/queries.generated";

type Data = {
    notBlocked: DomainNonPaymentBlockingCountQuery["domains"]["items"][0]["notBlocked"];
    outgoingBlocked: DomainNonPaymentBlockingCountQuery["domains"]["items"][0]["outgoingBlocked"];
    incomingAndOutgoingBlocked: DomainNonPaymentBlockingCountQuery["domains"]["items"][0]["incomingAndOutgoingBlocked"];
};

const initialData: Data = {
    notBlocked: 0,
    outgoingBlocked: 0,
    incomingAndOutgoingBlocked: 0,
};

export default class DataSource extends HookClass {
    public data!: MutableRefObject<Data>;
    public loaded!: boolean;
    protected domainId!: number;
    protected client!: ApolloClient<object>;
    protected setLoaded!: (value: boolean) => void;

    useHooks(domainId: number) {
        [this.loaded, this.setLoaded] = useState<boolean>(false);
        this.client = useApolloClient();
        this.domainId = domainId;
        this.data = useRef(initialData);
        useEffect(() => {
            this.fetch();
            return () => {
                this.data.current = initialData;
            };
        }, []);
    }

    async fetch() {
        this.setLoaded(false);

        const result = await this.client.query<
            DomainNonPaymentBlockingCountQuery,
            DomainNonPaymentBlockingCountQueryVariables
        >({
            query: DomainNonPaymentBlockingCountDocument,
            variables: {
                domainId: this.domainId,
            },
            fetchPolicy: "no-cache",
        });

        this.data.current = {
            notBlocked: result.data.domains.items[0].notBlocked,
            outgoingBlocked: result.data.domains.items[0].outgoingBlocked,
            incomingAndOutgoingBlocked: result.data.domains.items[0].incomingAndOutgoingBlocked,
        };

        this.setLoaded(true);
    }
}
